import { IPsrCustomerVulnerability } from "@/models/psr/psr.types"
import { Dayjs } from "dayjs"

export class PsrCustomerVulnerability implements IPsrCustomerVulnerability {
  id: number
  startDate: Dayjs
  label: string
  endDate?: Dayjs
  note?: string

  constructor(
    id: number,
    startDate: Dayjs,
    label: string,
    endDate?: Dayjs,
    note?: string,
  ) {
    this.id = id
    this.startDate = startDate
    this.endDate = endDate
    this.label = label
    this.note = note
  }
}
